import './styles/HealthByHost.css'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import data_ubi from './ubicaciones'
import { useFetch } from '../hooks/useFetch'
import RowProblem from './RowProblem'
import LoadAlerts from './LoadAlerts'
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from './generales/traduction'
const HealthByHost = ({ hostId, mode, server, languaje }) => {
  const health_list = useFetch('zabbix/hosts/detail/health', hostId, '', 'GET', server)

  return (
    <div className='ev-table-wrap' style={{ height: '300px' }}>
      <table className="ev-table">
        <thead className="ev-table-thead">
          <tr>
            <th style={{ width: '40px' }}>
              <input type="checkbox" disabled />
            </th>
            <th style={{ width: '10%' }}>ITEMID</th>
            <th style={{ width: '40%' }}>{capitalizeFirstLetter(lang[languaje]['metrica'])}</th>
            <th style={{ width: '25%' }}>{capitalizeFirstLetter(lang[languaje]['valor'])}</th>
            <th style={{ width: '15%' }}>{capitalizeFirstLetter(lang[languaje]['fecha'])}</th>
            <th style={{ width: '10%' }}>SEV.</th>
          </tr>
        </thead>
        <tbody className="ev-table-tbody">
          {health_list.loading ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}><LoadAlerts languaje={languaje} /></td></tr>
          ) : (!health_list.data || !health_list.data.data || health_list.data.data.length === 0) ? (
            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: '#9ca3af' }}>Sin resultados</td></tr>
          ) : (
            health_list.data.data.map((elemento, indice) => (
              <tr key={indice} className="ev-table-row">
                <td>
                  <input type="checkbox" disabled />
                </td>
                <td className="txt-futuristic">{elemento.itemid}</td>
                <td>
                  <div className="ev-link">{elemento.name}</div>
                </td>
                <td className="txt-futuristic" style={{ fontWeight: '700', color: '#1e40af' }}>
                  {(elemento.units != "") ? elemento.Metric + " (" + elemento.units + ")" : elemento.Metric}
                </td>
                <td className="txt-futuristic">{elemento.Date}</td>
                <td>
                  <div className="sev-pill s3" style={{ padding: '2px 8px', fontSize: '10px' }}>
                    S-3
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default HealthByHost